import { zSchema, schemes, EOrderStatus } from "@zeal/common";

export const getOrdersRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  customerAccountID: schemes.uuid().optional(),
  orderID: schemes.uuid().optional(),
  status: zSchema.array(zSchema.nativeEnum(EOrderStatus)).optional(),
  q: zSchema.string().optional(),
  createdDateFrom: zSchema.string().optional(),
  createdDateTo: zSchema.string().optional(),
  submittedDateFrom: zSchema.string().optional(),
  submittedDateTo: zSchema.string().optional(),
  start_at: zSchema.string().optional(),
  limit: zSchema.number().optional(),
  sort_direction: zSchema.enum(["asc", "desc"]).optional(),
  sort_by: zSchema.string().optional(),
});

export type TGetOrdersRequestSchema = zSchema.infer<
  typeof getOrdersRequestSchema
>;

export const getOrdersResponseSchema = zSchema.array(
  zSchema.object({
    companyID: schemes.uuid(),
    customerAccountID: schemes.uuid(),
    customer_name: zSchema.string(),
    createdAt: zSchema.date(),
    orderID: schemes.uuid(),
    businessCardID: zSchema.string().optional(),
    approval_required: zSchema.boolean(),
    approved: zSchema.boolean(),
    charge_processing_fee_to_customer: zSchema.boolean().optional(),
    contractor_payments: zSchema.array(schemes.mongoObjectId()).optional(),
    flat: zSchema.number(),
    memo: zSchema.string().optional(),
    order_total: zSchema.number(),
    payment_receipt_link: zSchema.string().optional(),
    status: zSchema.nativeEnum(EOrderStatus),
    submitted_at: zSchema.date().optional(),
    last_four: zSchema.string().optional(),
    transaction: zSchema.any().optional(),
    payments: zSchema.array(zSchema.any()).optional(),
  })
);

export type TGetOrdersResponseSchema = zSchema.infer<
  typeof getOrdersResponseSchema
>;
